import { IEnvironmentFromProcess } from '../environment.types'

export const readFromProcessEnv = (): IEnvironmentFromProcess => ({
  BUILD_ID:
    process.env['NEXT_PUBLIC_BUILD_ID'] || process.env['BUILD_ID'] || 'local',
  DATADOG_API_KEY:
    process.env['NEXT_PUBLIC_DATADOG_API_KEY'] ||
    process.env['DATADOG_API_KEY'],
  DATADOG_CLIENT_ID:
    process.env['NEXT_PUBLIC_DATADOG_CLIENT_ID'] ||
    process.env['DATADOG_CLIENT_ID'],
  DATADOG_RUM_APPLICATION_ID:
    process.env['NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID'] ||
    process.env['DATADOG_RUM_APPLICATION_ID'],
  DATADOG_RUM_CLIENT_TOKEN:
    process.env['NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN'] ||
    process.env['DATADOG_RUM_CLIENT_TOKEN'],
  DATADOG_RUM_GLOBAL_SAMPLE_RATE:
    process.env['NEXT_PUBLIC_DATADOG_RUM_GLOBAL_SAMPLE_RATE'] ||
    process.env['DATADOG_RUM_GLOBAL_SAMPLE_RATE'],
  DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE:
    process.env['NEXT_PUBLIC_DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE'] || '0',
  DATADOG_SERVICE_NAME:
    process.env['NEXT_PUBLIC_DATADOG_SERVICE_NAME'] ||
    process.env['DATADOG_SERVICE_NAME'],
})
